export * from './types';
export function add(n1, n2) {
    return n1 + n2 + 10;
}
